import { useEffect, useCallback } from 'react';

interface PlayerUpdateData {
  playerId: string;
  isDrafted: boolean;
  draftedBy: string | null;
  action: 'drafted' | 'undrafted' | 'updated';
}

interface UsePlayerUpdatesOptions {
  onPlayerUpdate?: (data: PlayerUpdateData) => void;
  refreshPlayers?: () => void;
  enabled?: boolean;
}

export const usePlayerUpdates = ({
  onPlayerUpdate,
  refreshPlayers,
  enabled = true
}: UsePlayerUpdatesOptions = {}) => {
  
  const handlePlayerUpdate = useCallback((event: CustomEvent<PlayerUpdateData>) => {
    try {
      const { action } = event.detail;
      
      // Call the custom callback if provided
      if (onPlayerUpdate) {
        onPlayerUpdate(event.detail);
      }
      
      // Refresh players if provided and action is relevant
      if (refreshPlayers && (action === 'drafted' || action === 'undrafted' || action === 'updated')) {
        refreshPlayers();
      }
    } catch (error) {
      console.error('Error handling player update:', error);
    }
  }, [onPlayerUpdate, refreshPlayers]);

  useEffect(() => {
    if (!enabled) return;

    window.addEventListener('playerUpdated', handlePlayerUpdate as EventListener);

    return () => {
      window.removeEventListener('playerUpdated', handlePlayerUpdate as EventListener);
    };
  }, [handlePlayerUpdate, enabled]);

  return {
    // Return any additional utilities if needed
  };
};
